import clsx from 'clsx';
import { FaWhatsapp, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import Link from 'next/link';
const NavBarContactDetails = () => {
    const rowClasses = clsx(
        'flex',
        'flex-row',
        'p-1',
        'justify-self-end',
        'items-center'
    );

    const iconClasses = clsx(
        'flex',
        'items-center',
        'justify-center',
        'rounded-full',
        'bg-black',
        'w-7',
        'h-7',
        'mr-2'
    );

    const textClasses = clsx('text-xs', 'text-balance', 'w-[240px]');

    return (
        <div className="w-50 h-50 absolute top-0 right-0 z-10">
            <Link href="tel:+441344843050">
                <div className={rowClasses}>
                    <div className={iconClasses}>
                        <FaPhoneAlt color="white" size={14} />
                    </div>
                    <div className={textClasses}>+44 1344 843 050</div>
                </div>
            </Link>

            <Link href="mailto:booking@pennycarhire.co.uk">
                <div className={rowClasses}>
                    <div className={iconClasses}>
                        <FaEnvelope color="white" size={14} />
                    </div>
                    <div className={textClasses}>
                        booking@pennycarhire.co.uk
                    </div>
                </div>
            </Link>

            <Link href="whatsapp://call?number=+441344843050">
                <div className={rowClasses}>
                    <div className={iconClasses}>
                        <FaWhatsapp size={20} color="white" />
                    </div>
                    <div className={textClasses}>
                        WhatsApp calling works on our main number but only
                        during working hours
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default NavBarContactDetails;
